export const PointBoxberry = () => (
	<svg width="50" height="58" viewBox="0 0 50 58" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g filter="url(#filter0_dd_25188_21669)">
			<path
				d="M40 19.75C40 32.6875 25 40 25 40C25 40 10 32.4062 10 19.75C10 11.0515 16.7157 4 25 4C33.2843 4 40 11.0515 40 19.75Z"
				fill="#ED1752"
			/>
		</g>
		<g clipPath="url(#clip0_25188_21669)">
			<path
				d="M23.5779 15.2057C23.5779 16.2807 22.6743 17.1267 21.5243 17.1267C20.4153 17.1167 19.522 16.2707 19.5117 15.2157C19.5117 14.1507 20.4358 13.2748 21.5653 13.2848C22.6743 13.2947 23.5779 14.1606 23.5779 15.2057Z"
				fill="white"
			/>
			<path
				d="M21.5549 19.8535C22.6947 19.8535 23.5983 20.7194 23.5777 21.7944C23.5675 22.8395 22.6433 23.6954 21.5446 23.6855C20.4151 23.6855 19.5013 22.8096 19.5218 21.7347C19.5218 20.6896 20.4254 19.8535 21.5549 19.8535Z"
				fill="white"
			/>
			<path
				d="M23.0029 18.4799C23.0029 17.395 23.9065 16.559 25.0566 16.5689C26.1552 16.5789 27.0691 17.4548 27.0691 18.4899C27.0691 19.535 26.1552 20.3909 25.0463 20.4009C23.8963 20.4109 23.0029 19.5648 23.0029 18.4799Z"
				fill="white"
			/>
			<path
				d="M23.0029 24.9741C23.0029 23.8892 23.9065 23.0531 25.0566 23.0631C26.1552 23.073 27.0691 23.9489 27.0691 24.984C27.0691 26.0291 26.1552 26.8851 25.0463 26.895C23.8963 26.905 23.0029 26.059 23.0029 24.9741Z"
				fill="white"
			/>
			<path
				d="M23.0029 11.9111C23.0029 10.8262 23.9065 9.99013 25.0566 10.0001C26.1552 10.01 27.0691 10.8859 27.0691 11.921C27.0691 12.9661 26.1552 13.8221 25.0463 13.8321C23.8963 13.842 23.0029 12.996 23.0029 11.9111Z"
				fill="#A6CE39"
			/>
			<path
				d="M28.5063 17.1166C27.3563 17.1166 26.463 16.2706 26.4732 15.1857C26.4835 14.1307 27.3768 13.2847 28.496 13.2847C29.6153 13.2847 30.5599 14.1805 30.5394 15.2255C30.5189 16.2706 29.6153 17.1166 28.5063 17.1166Z"
				fill="white"
			/>
			<path
				d="M28.4963 23.6857C27.3668 23.6757 26.4632 22.8098 26.4837 21.7249C26.5043 20.6699 27.3873 19.8438 28.5168 19.8438C29.6258 19.8438 30.5294 20.6898 30.5396 21.7448C30.5499 22.7998 29.6052 23.6956 28.4963 23.6857Z"
				fill="white"
			/>
			<path
				d="M31.9359 20.4011C30.827 20.3812 29.9542 19.5252 29.9644 18.4602C29.9747 17.3853 30.8783 16.5492 32.0283 16.5592C33.1373 16.5691 34.0101 17.4251 33.9998 18.5C33.9793 19.5849 33.0757 20.421 31.9359 20.4011Z"
				fill="white"
			/>
			<path
				d="M17.9716 20.4011C16.8626 20.3812 15.9898 19.5252 16.0001 18.4602C16.0104 17.3853 16.914 16.5492 18.064 16.5592C19.1729 16.5691 20.0457 17.4251 20.0355 18.5C20.0149 19.5849 19.1113 20.421 17.9716 20.4011Z"
				fill="white"
			/>
		</g>
		<defs>
			<filter
				id="filter0_dd_25188_21669"
				x="0"
				y="0"
				width="50"
				height="58"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB">
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="8" />
				<feGaussianBlur stdDeviation="5" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.1 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25188_21669" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset dy="4" />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0.160784 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.05 0" />
				<feBlend mode="normal" in2="effect1_dropShadow_25188_21669" result="effect2_dropShadow_25188_21669" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_25188_21669" result="shape" />
			</filter>
			<clipPath id="clip0_25188_21669">
				<rect width="18" height="17" fill="white" transform="translate(16 10)" />
			</clipPath>
		</defs>
	</svg>
)
